export default {
  termsVersions: {
    current: '08-05-2026',
    all: ['15-05-2024', '21-05-2025', '08-05-2026'],
  }, 
}
